import i18next from "i18next";
import { Button, Card, Space, Tooltip, Select, Row, Col, Input, Form, Radio, Spin } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { InfoCircleFilled, CloseOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { user_state } from '../../../features/user/userSlice';
import { MapService } from "../../../service/mapService";

const { TextArea } = Input;


const LayersAdministrationComponent = ({ dataMaps, dataRoles }) => {

    const dispatch = useDispatch();
    const userstate = useSelector(user_state);

    const [cargando, setCargando] = useState(false)

    const [selectedMap, setSelectedMap] = useState(undefined);
    const [selectedLayer, setSelectedLayer] = useState(undefined);
    const [inputId, setInputID] = useState("")
    const [inputNombre, setInputNombre] = useState("")
    const [inputType, setInputType] = useState("")
    const [inputDescripcion, setInputDescripcion] = useState("")
    const [inputPosition, setInputPosition] = useState("")
    const [selectedRol, setSelectedRol] = useState(undefined)
    const [inputService, setInputService] = useState("Public")

    const [valueTextAreaConfigPrincipal, setValueTextAreaConfigPrincipal] = useState('{}');
    const [valueTextAreaConfigSecundaria, setValueTextAreaConfigSecundaria] = useState('{}');

    const [selectMapOptions, setSelectMapOptions] = useState([]);
    const [selectLayerOptions, setSelectLayerOptions] = useState([])

    const [rolUser, setRolUser] = useState(undefined);
    const [datosMaps, setDatosMaps] = useState(dataMaps)
    const [datosRoles, setDataRoles] = useState(dataRoles)
    const [datosLayers, setDatosLayers] = useState([])


    let windowHeight = window.innerHeight

    /**
     * Funcion que recoge el valor de los textareas
     * 
     * @param {*} e 
     */
    const handleInputChange = (e) => {
        let reader = new FileReader();
        switch (e.target.id) {
            case "confprim":
                reader.onload = function (e) {
                    setValueTextAreaConfigPrincipal(e.target.result)
                }
                reader.readAsText(e.target.files[0])
                break;
            case "confsec":
                reader.onload = function (e) {
                    setValueTextAreaConfigSecundaria(e.target.result)
                }
                reader.readAsText(e.target.files[0])
                break;
            default:
                break;
        }
    }

    const submit = () => {
        console.log(selectedMap)
        console.log(inputId)
        console.log(selectedLayer)
        console.log(inputNombre)
        console.log()
        console.log(inputDescripcion)
        console.log(selectedRol)
    }

    /**
     * función que devuelve todos los valores de los inputs a su valor original
     */
    const reset = () => {
        setSelectedMap(undefined)
        setSelectedLayer(undefined)
        setInputID("")
        setInputNombre("")
        setInputType("")
        setInputDescripcion("")
        setInputPosition("")
        setSelectedRol(undefined)
        setInputService("Public")
        setValueTextAreaConfigPrincipal("")
        setValueTextAreaConfigSecundaria("")
    }


    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    /**
     * Función que modifica el valor del input del boton radio
     * 
     * @param {*} e 
     */
    const onChangeRadioButton = (e) => {
        console.log('radio checked', e.target.value);
        setInputService(e.target.value);
    };

    /**
 * Función que convierte los datos de los mapas a un formato legible en un select
 * 
 * @returns 
 */
    const getSelectMapOptions = () => {
        let dataCopy = [...datosMaps]
        //console.log("copia", dataCopy)
        return dataCopy.map((dato) => {
            return {
                "value": dato.id,
                "label": dato.name
            }
        })
    }

    /**
 * Función que convierte los datos de los roles a un formato legible en un select
 */
    const getSelectRolOptions = () => {
        let dataCopy = [...datosRoles]
        //console.log("data roles", dataCopy)
        return dataCopy.map((dato) => {
            return {
                "value": dato.idRol,
                "label": dato.name
            }
        })
    }

    /**
 * Cuando se clica el boton Crear se resetean los valores de los inputs
 */
    const onClickCrear = () => {
        reset()
    }


    /**
     * Cuando se clica el boton modificar se muestran en los inputs los valores relacionados a ese mapa
     */
    const onClickModificar = async () => {
        //console.log("mapa id", selectedMap)
        setCargando(true)
        let datosCopy = [...datosLayers]

        let datosLayer = datosCopy.find((layer) => layer.id == selectedLayer)
        //console.log("mapa", datosMapa)
        if (datosLayer) {
            setInputID(datosLayer.id)
            setInputNombre(datosLayer.name)
            setInputType(datosLayer.type)
            setInputDescripcion(datosLayer.description)
            setInputPosition(datosLayer.position)
            setSelectedRol(datosLayer.rol)
            setInputService(datosLayer.service)
            setValueTextAreaConfigPrincipal(JSON.stringify(datosLayer.confp))
            setValueTextAreaConfigSecundaria(datosLayer.confs)
            setCargando(false)
        } else {
            reset()
        }
    }

    const onClickBorrar = async () => {
        alert("TODO")
    }

    useEffect(() => {
        //console.log("render", getSelectMapOptions())
        //console.log("user", userstate)
        setSelectMapOptions(getSelectMapOptions())
        //setRolUser()
    }, [])

    useEffect(() => {
        //console.log("mapa seleccionado", selectedMap)
        if (selectedMap != undefined) {
            MapService.getMap(selectedMap)
                .then((data) => {
                    //console.log("SgvMapByIdComponent getMapContent", data.sgvmapMapMaplyrList[4]);
                    //setMapConfig(data)
                    let arrayOpciones = data.sgvmapMapMaplyrList.map((dato) => {
                        return {
                            "value": dato.sgvmapMapLayer.idMapLayer,
                            "label": dato.sgvmapMapLayer.name
                        }
                    })
                    setSelectLayerOptions(arrayOpciones)
                    let arrayCapas = data.sgvmapMapMaplyrList.map((dato) => {
                        return {
                            "id": dato.sgvmapMapLayer.idMapLayer,
                            "name": dato.sgvmapMapLayer.name,
                            "type": dato.sgvmapMapLayer.type,
                            "description": dato.sgvmapMapLayer.description,
                            "position": dato.orderPosition,
                            "rol": dato.sgvmapMapMaplyrPK.idRol,
                            "service": dato.sgvmapMapLayer.srvSecsMapLayers.length > 0 ? "Private" : "Public",
                            "confp": dato.sgvmapMapLayer.conf,
                            "confs": dato.config
                        }
                    })
                    setDatosLayers(arrayCapas)
                })
                .catch(err => {
                    console.log('error', err)
                    setSelectLayerOptions([])
                    setDatosLayers([])
                    err.response.json().then(res => {
                        //console.log('error',res);
                    });
                })
        }

    }, [selectedMap])

    return (
        <>
            <Card>
                <Row>
                    <Col span={6}>
                        <Space direction="vertical">
                            <h2>{i18next.t('common.administration.tab_layer.header.options')}</h2>
                            <div>
                                <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedLayer == undefined ? false : true}
                                    onClick={(e) => onClickCrear()}>{i18next.t('common.administration.tools.boton_crear.name')}</Button>
                                <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_crear.info')}>
                                    {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                </Tooltip>
                            </div>
                            <div>
                                <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedLayer == undefined ? true : false}
                                    onClick={(e) => onClickModificar()}>{i18next.t('common.administration.tools.boton_modificar.name')}</Button>
                                <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_modificar.info')}>
                                    {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                </Tooltip>
                            </div>
                            <div>
                                <Button style={{ "marginRight": "5px", "width": "130px" }} size="large" disabled={selectedLayer == undefined ? true : false}
                                    onClick={(e) => onClickBorrar()}>{i18next.t('common.administration.tools.boton_borrar.name')}</Button>
                                <Tooltip placement="right" title={i18next.t('common.administration.tools.boton_borrar.info')}>
                                    {<InfoCircleFilled style={{ fontSize: '16px', color: '#08c' }} />}
                                </Tooltip>
                            </div>
                            <div>
                                <p>{i18next.t('common.administration.tab_layer.fields.select_map')}</p>
                                <Select
                                    showSearch
                                    allowClear
                                    value={selectedMap}
                                    placeholder="Select a map"
                                    optionFilterProp="children"
                                    onChange={(e) => setSelectedMap(e)}
                                    filterOption={filterOption}
                                    options={selectMapOptions}
                                />
                            </div>
                            <div>
                                <p>{i18next.t('common.administration.tab_layer.fields.select_layer')}</p>
                                <Select
                                    showSearch
                                    allowClear
                                    value={selectedLayer}
                                    placeholder="Select a layer"
                                    optionFilterProp="children"
                                    onChange={(e) => setSelectedLayer(e)}
                                    filterOption={filterOption}
                                    options={selectLayerOptions}
                                />
                            </div>
                            {
                                cargando && <div>
                                    <Space>
                                        <Spin /> <p>CARGANDO...</p>
                                    </Space>
                                </div>
                            }
                        </Space>
                    </Col>
                    <Col span={18}>
                        <Row>
                            <Col span={24} style={{ "textAlign": "center" }}>
                                <h2>{i18next.t('common.administration.tab_layer.header.data')}</h2>
                            </Col>
                        </Row>
                        <Row>

                            <Col span={8} style={{ "padding": "10px" }}>
                                <Form
                                    layout={"vertical"}
                                >
                                    <Form.Item label={i18next.t('common.administration.tab_layer.fields.id')}>
                                        <Input placeholder="input placeholder" value={inputId} onChange={(e) => setInputID(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_layer.fields.name')}>
                                        <Input placeholder="input placeholder" value={inputNombre} onChange={(e) => setInputNombre(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_layer.fields.type')}>
                                        <Input placeholder="input placeholder" value={inputType} onChange={(e) => setInputType(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_layer.fields.description')}>
                                        <Input placeholder="input placeholder" value={inputDescripcion} onChange={(e) => setInputDescripcion(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_layer.fields.position')}>
                                        <Input placeholder="input placeholder" value={inputPosition} onChange={(e) => setInputPosition(e.target.value)} />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_layer.fields.role')}>
                                        <Select
                                            showSearch
                                            value={selectedRol}
                                            placeholder="Select a rol"
                                            optionFilterProp="children"
                                            onChange={(e) => setSelectedRol(e)}
                                            filterOption={filterOption}
                                            options={getSelectRolOptions()}
                                        />
                                    </Form.Item>
                                    <Form.Item label={i18next.t('common.administration.tab_layer.fields.service_type.name')}>
                                        <Radio.Group onChange={onChangeRadioButton} value={inputService}>
                                            <Radio value={"Public"}>{i18next.t('common.administration.tab_layer.fields.service_type.public')}</Radio>
                                            <Radio value={"Private"}>{i18next.t('common.administration.tab_layer.fields.service_type.private')}</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </Form>
                            </Col>
                            <Col span={16} style={{ "padding": "10px" }}>
                                <Row>
                                    <Col span={24}>
                                        <Form layout={"vertical"}>
                                            <Form.Item label={i18next.t('common.administration.tab_layer.fields.configuration_p.name')}>
                                                <div style={{ "display": "flex" }}>
                                                    <div style={{ "marginRight": "auto" }}>
                                                        <input
                                                            id='confsec'
                                                            type="file"
                                                            onChange={handleInputChange}
                                                            accept=".json"
                                                        />
                                                    </div>
                                                    <div>
                                                        <Tooltip title={i18next.t('common.administration.tools.icono_borrar.info')}>
                                                            <Button type="link" danger style={{ "border": "none" }} onClick={() => setValueTextAreaConfigPrincipal("")}>
                                                                {<CloseOutlined style={{ "color": "red" }} />}
                                                            </Button>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                <TextArea value={valueTextAreaConfigPrincipal} style={{ height: windowHeight / 2, resize: 'none' }} onChange={(e) => setValueTextAreaConfigPrincipal(e.target.value)} />
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <Form layout={"vertical"}>
                                            <Form.Item label={i18next.t('common.administration.tab_layer.fields.configuration_s.name')}>
                                                <div style={{ "display": "flex" }}>
                                                    <div style={{ "marginRight": "auto" }}>
                                                        <input
                                                            id='confsec'
                                                            type="file"
                                                            onChange={handleInputChange}
                                                            accept=".json"
                                                        />
                                                    </div>
                                                    <div>
                                                        <Tooltip title={i18next.t('common.administration.tools.icono_borrar.info')}>
                                                            <Button type="link" danger style={{ "border": "none" }} onClick={() => setValueTextAreaConfigSecundaria("")}>
                                                                {<CloseOutlined style={{ "color": "red" }} />}
                                                            </Button>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                <TextArea value={valueTextAreaConfigSecundaria} style={{ height: windowHeight / 5, resize: 'none' }} onChange={(e) => setValueTextAreaConfigSecundaria(e.target.value)} />
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col span={24} style={{ "textAlign": "center", "marginTop": "15px" }}>
                        <Space>
                            <Button size="large" onClick={() => submit()}>{i18next.t('common.administration.tools.boton_guardar.name')}</Button>
                            <Button size="large" onClick={() => reset()}>{i18next.t('common.administration.tools.boton_cancelar.name')}</Button>
                        </Space>
                    </Col>
                </Row>
            </Card>
        </>
    );

}

export default LayersAdministrationComponent;